import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import {
  selectJiraIsProjectLoading,
  selectJiraTypesAsOptions,
} from 'ducks/integrations/jiraShared'
import ValidatedField from 'shared/components/ui/ValidatedField'
import { Label } from 'shared/ui'
import { Dropdown } from 'util/ui'

import FormRow from 'components/App/DesktopView/Layout/RightSidebar/InAppCards/shared/LinkResource/FormRow'
import OptionImageIcon from 'components/App/DesktopView/Layout/RightSidebar/InAppCards/shared/LinkResource/OptionImageIcon'

export default connect(
  (state, { formFields: { project: projectId }, siteId }) => {
    return {
      areTypesLoading: selectJiraIsProjectLoading(state, {
        projectId,
        source: 'jiraServer',
      }),
      types: selectJiraTypesAsOptions(state, {
        projectId,
        siteId,
        source: 'jiraServer',
      }),
    }
  }
)(TypesFormField)

function TypesFormField({
  areTypesLoading,
  isProjectChoosen,
  formFields: { type },
  onChange,
  resetFields,
  siteId,
  types,
}) {
  useEffect(
    () => {
      resetFields('types')
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [siteId]
  )
  return (
    <FormRow split>
      <Label as="div">Type</Label>
      <ValidatedField
        disabled={!isProjectChoosen || areTypesLoading}
        fluid
        loading={areTypesLoading}
        name="type"
        options={
          types &&
          types
            .map(option => {
              return {
                ...option,
                icon: (
                  <OptionImageIcon alt={option.text} src={option.iconUrl} />
                ),
              }
            })
            .filter(option => option.text !== 'Epic')
        }
        onChange={onChange}
        placeholder="- Please select -"
        search
        selection
        selectOnNavigation={false}
        validatedFieldComponent={Dropdown}
        value={type}
      />
    </FormRow>
  )
}
